import { schema } from "normalizr";

export const paymentSchema = new schema.Entity("payment", {});
export const arrayOfPaymentSchemas = new schema.Array(paymentSchema);
